import { useState, useEffect, useRef } from "react";
import "react-alice-carousel/lib/alice-carousel.css";
import physics from "../../assets/img/Physics.jpg";
import maths from "../../assets/img/Maths.jpg";
import chemistry from "../../assets/img/chemistry.jpg";
import English from "../../assets/img/English.jpg";
import sst from "../../assets/img/sst.jpg";
import science from "../../assets/img/Science.jpg"
import AliceCarousel from "react-alice-carousel";

function Courses() {
  const courses = [
    {
      id: 2,
      title: "Maths",
      description: "Class 6th to 12th",
      image: maths,
    },
    {
      id: 3,
      title: "Physics",
      description: "Exclusively for class 11th and 12th",
      image: physics,
    },
    {
      id: 4,
      title: "Chemistry",
      description: "Exclusively for class 11th and 12th",
      image: chemistry,
    },
    {
      id: 1,
      title: "Social Studies",
      description: "For class 6th to 8th",
      image: sst,
    },
    {
      id: 5,
      title: "English",
      description: "For class 6th to 10th",
      image: English,
    },
    {
      id: 6,
      title: "Science",
      description: "For class 6th to 10th",
      image: science,
    }
  ];

  const [isDesktop, setIsDesktop] = useState(false);
  const coursesRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const responsive = {
    0: { items: 1 },
    768: { items: 3 },
  };

  return (
    <div className="container mb-5">
      <h5 className="orange-text text-center fw-bold p-3">Courses</h5>
      <h2 className="blue-text text-center fw-bolder p-3">Featured Courses</h2>
      <div className="courses-carousel" ref={coursesRef}>
        <AliceCarousel
          mouseTracking
          items={courses.map((course) => (
            <div className="card mx-2" style={{height:"14rem"}} key={course.id}>
              <div className="card-img-overlay d-flex flex-column justify-content-end">
                <h5 className="card-title fs-3 fw-bolder text-light">{course.title}</h5>
                <p className="card-text fs-4 fw-bold text-light">{course.description}</p>
              </div>
              <img
                src={course.image}
                className="card-img-top"
                alt={`${course.title}`}
              />
            </div>
          ))}
          responsive={responsive}
          autoPlay
          autoPlayInterval={2000}
          animationDuration={500}
          disableDotsControls={!isDesktop}
          disableButtonsControls
          swipeDisabled={!isDesktop}
        />
      </div>
    </div>
  );
}

export default Courses;
